// extracted by mini-css-extract-plugin
module.exports = {"community_container":"Community_community_container__mbtvY","avatar_empty":"Community_avatar_empty__1CMGR","community_name":"Community_community_name__1WOtK"};